// pages/Demo.js
import React, { useState } from 'react';
import './Pages.css';

const Demo = () => {
  const [count, setCount] = useState(0);
  const [message, setMessage] = useState('');

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Interactive Demo</h1>
        <p>Experience our components in action</p>
      </div>
      <div className="page-content">
        <div className="demo-section">
          <div className="demo-card">
            <h3>Interactive Counter</h3>
            <div className="counter-demo">
              <button onClick={() => setCount(count - 1)}>-</button>
              <span className="counter-value">{count}</span>
              <button onClick={() => setCount(count + 1)}>+</button>
            </div>
          </div>
          
          <div className="demo-card">
            <h3>Message Board</h3>
            <input 
              type="text" 
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="demo-input"
            />
            <p className="message-preview">Your message: {message || '...'}</p>
          </div>

          <div className="demo-card">
            <h3>Features Showcase</h3>
            <ul className="feature-list">
              <li>✓ Fully Responsive Design</li>
              <li>✓ Smooth Animations</li>
              <li>✓ React Router Integration</li>
              <li>✓ Mobile-Friendly Navigation</li>
              <li>✓ Modern UI Components</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demo;